import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MenuService } from '@cadriciel/core';
import { LayoutService } from '@shared/layouts/cerema-layout/service/layout.service';
import { AuthService } from '@shared/auth/auth.service';
import { APP_MENU } from './app.menu';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('ceremabo');

  private menuService = inject(MenuService);
  private layoutService = inject(LayoutService);
  private authService = inject(AuthService);

  constructor() {
    this.menuService.setMenu(APP_MENU);
  }
}
